export default {
  SET_TITLE: "SET_TITLE",
  SET_DESCRIPTION: "SET_DESCRIPTION",
  SET_TITLE_BUTTON: "SET_TITLE_BUTTON",
  SET_COLOR_BUTTON: "SET_COLOR_BUTTON",
  SET_COLOR_TEXT_BUTTON: "SET_COLOR_TEXT_BUTTON",
  SET_LOGO: "SET_LOGO",
  SET_BANNER: "SET_BANNER",
  SET_BACKGROUND_COLOR_DETAILS_AREA: "SET_BACKGROUND_COLOR_DETAILS_AREA",
  SET_BORDER_RADIUS_BUTTON: "SET_BORDER_RADIUS_BUTTON",
  RESET_BANNER: "RESET_BANNER",
};
